<template>
  <div class="newsdetails-box" :class="{ 'is-share-page': isSharePage }">
    <div v-if="isSharePage" class="share-download-bar">
      <img :src="topBrandImage" class="share-download-brand" alt="99手游 发掘好游戏" />
      <button type="button" class="share-download-action" @click="handleShareAction">
        下载
      </button>
    </div>

    <div class="newsdetails-content" :class="{ 'has-share-entry': isSharePage }">
      <div v-if="state.title" class="main-title">{{ state.title }}</div>
      <div v-if="state.time" class="contentbox">
        <span class="tapv" :style="{color: getTagColor(state.titlelb)}">{{ state.titlelb }}</span>
        <span class="line"></span>
        <span class="timev">{{ state.time }}</span>
      </div>
      <!-- 添加class以便强化文章内容间距样式 -->
      <div class="article-content" v-html="state.content" @click="openInagePreview"></div>
    </div>
    <van-image-preview
      v-model:show="state.imgPreviewFlag"
      :images="state.images"
      id="imgPreview"
    >
      <template #cover>
        <div class="withImage" v-if="state.imgPreviewFlag">
          <img src="../../../assets/ico_download.png" alt="" @click="saveImg" style="display: none;"/>
        </div>
      </template>
    </van-image-preview>

    <button
      v-if="isSharePage"
      type="button"
      class="share-open-button"
      @click="handleShareAction"
    >
      <img :src="appIconImage" alt="" />
      <span>99手游打开</span>
    </button>

    <van-popup
      v-model:show="state.iosGuideVisible"
      class="share-guide-popup ios-guide-popup"
      :style="{ width: '92vw', maxHeight: '90vh', overflowY: 'auto' }"
      round
      teleport="body"
      :close-on-click-overlay="false"
    >
      <div class="guide-dialog">
        <button
          type="button"
          class="guide-close"
          aria-label="关闭"
          @click="state.iosGuideVisible = false"
        >
          ×
        </button>
        <div class="guide-title">iOS如何打开“99手游”</div>
        <div class="guide-description">iOS仅支持网页版，不支持直接唤起，需手动操作</div>

        <img
          :src="iosDesktopGuideImage"
          class="guide-panel-image"
          alt="已添加99手游到桌面的打开方式"
        />

        <div class="ios-copy-panel">
          <img
            :src="iosCopyGuideImage"
            class="guide-panel-image"
            alt="未添加99手游到桌面的打开方式"
          />
          <button type="button" class="guide-copy-button" @click="handleCopyLink">
            复制链接
          </button>
        </div>
      </div>
    </van-popup>

    <van-popup
      v-model:show="state.androidGuideVisible"
      class="share-guide-popup android-guide-popup"
      :style="{ width: '92vw', maxHeight: '90vh', overflowY: 'auto' }"
      round
      teleport="body"
      :close-on-click-overlay="false"
    >
      <div class="guide-dialog android-guide-dialog">
        <button
          type="button"
          class="guide-close"
          aria-label="关闭"
          @click="state.androidGuideVisible = false"
        >
          ×
        </button>
        <div class="android-guide-title">QQ/微信内暂不支持直接打开APP</div>
        <div class="android-guide-description">若已安装，可直接从手机桌面打开99手游</div>
        <img
          :src="androidDesktopGuideImage"
          class="android-guide-image"
          alt="从手机桌面打开99手游"
        />
        <button type="button" class="android-download-button" @click="openAndroidGuideSite">
          我未安装，去下载99手游
        </button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { computed, onBeforeUnmount, reactive } from "vue";
import { useRouter, useRoute } from "vue-router";
import { Toast } from "vant";
import { newsdetail } from "@/api/yzgame";
import {
  ANDROID_GUIDE_URL,
  IOS_SITE_URL,
  copyText,
  createAndroidAppOpener,
  detectShareEnvironment,
} from "@/utils/shareApp";
import topBrandImage from "@/assets/newsShare/top-brand.webp";
import appIconImage from "@/assets/newsShare/app-icon.webp";
import iosCopyGuideImage from "@/assets/newsShare/ios-copy-guide.png";
import androidDesktopGuideImage from "@/assets/newsShare/android-desktop-guide.png";
import iosDesktopGuideImage from "@/assets/newsShare/ios-desktop-guide.png";
// import { handleSaveImg } from "../../../utils/tool"; // 未使用，可移除

export default {
  name: "newsdetails",
  setup() {
    const router = useRouter();
    const route = useRoute();
    const isSharePage = computed(() => route.query.isshare === "1");
    const shareEnvironment = detectShareEnvironment();
    const androidAppOpener = createAndroidAppOpener();

    const state = reactive({
      // title: '活动标题', // time: '2021-03-07', // content: '活动内容'
      images: [],
      imgPreviewFlag: false,
      title: "",
      time: "",
      content: "",
      titlelb: "",
      iosGuideVisible: false,
      androidGuideVisible: false,
    });

    console.log(route.query.id);
    newsdetail({
      id: route.query.id,
    }).then((response) => {
      console.log("详情------------------------", response);
      state.title = response.data.post_title;
      if (state.title) {
        document.title = state.title;
      }
      state.time = response.data.post_date;
      state.content = response.data.post_content;
      state.titlelb = response.data.titlelb;
    });
    const openInagePreview = (e) => {
      if (e.target.tagName.toLowerCase() === "img") {
        console.log(e.target.src);
        //window.JsBridge.skipImageActivity(e.target.src);
         state.images[0] = e.target.src;
         console.log("打开图片预览成功", state.images);
         state.imgPreviewFlag = true;
      }
    };
    const saveImg = () => {
      console.log("保存图片到本地-----", state.images[0]);
      // handleSaveImg(state.images[0]);
      // 保存图片到本地
    };

    const handleShareAction = () => {
      if (!isSharePage.value) return;

      if (shareEnvironment.isIOS) {
        if (shareEnvironment.isInnerBrowser) {
          state.iosGuideVisible = true;
        } else {
          window.location.href = IOS_SITE_URL;
        }
        return;
      }

      if (shareEnvironment.isAndroid) {
        if (shareEnvironment.isInnerBrowser) {
          state.androidGuideVisible = true;
        } else {
          androidAppOpener.open();
        }
        return;
      }

      window.location.href = IOS_SITE_URL;
    };

    const handleCopyLink = async () => {
      try {
        await copyText(IOS_SITE_URL);
        Toast("复制成功，请前往 Safari 粘贴打开");
      } catch (error) {
        Toast("复制失败，请长按链接手动复制");
      }
    };

    const openAndroidGuideSite = () => {
      window.location.href = ANDROID_GUIDE_URL;
    };

    onBeforeUnmount(() => {
      androidAppOpener.cancel();
    });

    const getTagColor = (str)=>{
      
      if(str == '游戏活动'){
        return '#12cdb0'
      }
      if(str == '游戏攻略'){
        return '#ff9000'
      }
      if(str == '转游规则'){
        return '#b134eb'
      }
      if(str == '游戏下架'){
        return '#eb5834'
      }
      if(str == '常见问题'){
        return '#34a1eb'
      }
      return "#12cdb0"
    }

    // 返回
    const onClickLeft = () => {
      router.back();
    };
    return {
      state,
      onClickLeft,
      openInagePreview,
      saveImg,
      getTagColor,
      isSharePage,
      handleShareAction,
      handleCopyLink,
      openAndroidGuideSite,
      topBrandImage,
      appIconImage,
      iosCopyGuideImage,
      androidDesktopGuideImage,
      iosDesktopGuideImage,
    };
  },
};
</script>

<style src="../../../styles/editor.css" scoped></style>
<style scoped="scoped">
div,span,p{
  font-family: -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica, Segoe UI, Arial, Roboto, 'PingFang SC', miui, 'Hiragino Sans GB', 'Microsoft Yahei', sans-serif !important;
}

button {
  border: 0;
  font: inherit;
}

.share-download-bar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1100;
  box-sizing: border-box;
  width: 100%;
  height: 96px;
  padding: 14px 24px;
  display: flex;
  align-items: center;
  gap: 20px;
  background: #f4f5f6;
  border-bottom: 1px solid #ebedf0;
}

.newsdetails-box.is-share-page {
  padding-top: 96px;
}

.share-download-brand {
  display: block;
  flex: 1;
  min-width: 0;
  max-width: calc(100% - 132px);
  max-height: 60px;
  object-fit: contain;
  object-position: left center;
}

.share-download-action {
  flex: 0 0 112px;
  height: 62px;
  padding: 0;
  color: #00d9c5;
  font-size: 28px;
  font-weight: 600;
  line-height: 60px;
  background: transparent;
  border: 2px solid #00d9c5;
  border-radius: 34px;
}

.share-open-button {
  position: fixed;
  left: 50%;
  bottom: calc(28px + env(safe-area-inset-bottom));
  z-index: 1000;
  width: 380px;
  height: 88px;
  padding: 0 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  color: #fff;
  font-size: 32px;
  font-weight: 800;
  background: linear-gradient(115deg, #00cbb7 0%, #00a4d6 100%);
  border: 1px solid rgba(255, 255, 255, 0.42);
  border-radius: 48px;
  box-shadow: 0 10px 28px rgba(0, 132, 181, 0.26), inset 0 1px 0 rgba(255, 255, 255, 0.28);
  transform: translateX(-50%);
}

.share-open-button img {
  box-sizing: border-box;
  width: 58px;
  height: 58px;
  border: 3px solid #fff;
  border-radius: 13px;
}

.share-open-button span {
  font-weight: 800;
}

:deep(.share-guide-popup) {
  width: 660px;
  max-height: calc(100vh - 80px);
  overflow-y: auto;
  background: #fff;
}

.guide-dialog {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  padding: 66px 30px 32px;
}

.guide-close {
  position: absolute;
  top: 18px;
  right: 18px;
  z-index: 2;
  width: 56px;
  height: 56px;
  padding: 0;
  color: #969799;
  font-size: 50px;
  font-weight: 300;
  line-height: 50px;
  background: #f1f2f3;
  border-radius: 50%;
}

.guide-title {
  width: fit-content;
  margin: 0 auto 28px;
  padding: 18px 34px;
  color: #5e4923;
  font-size: 34px;
  font-weight: 700;
  line-height: 1.25;
  white-space: nowrap;
  background: #ffe7a4;
  border-radius: 44px;
}

.guide-description {
  margin-bottom: 26px;
  color: #242424;
  font-size: 26px;
  line-height: 1.5;
  text-align: center;
}

.guide-panel-image,
.android-guide-image {
  display: block;
  width: 100%;
  height: auto;
}

.ios-copy-panel {
  position: relative;
  margin-top: 24px;
}

.guide-copy-button {
  position: absolute;
  top: 38%;
  left: 12%;
  width: 76%;
  height: 76px;
  padding: 0;
  color: #fff;
  font-size: 32px;
  font-weight: 700;
  background: #00d9c5;
  border-radius: 48px;
  transform: translateY(-50%);
}

.android-guide-dialog {
  padding-top: 78px;
  padding-bottom: 52px;
}

.android-guide-title {
  color: #222;
  font-size: 30px;
  font-weight: 600;
  line-height: 1.4;
  text-align: center;
}

.android-guide-description {
  margin-top: 12px;
  color: #555;
  font-size: 25px;
  line-height: 1.4;
  text-align: center;
}

.android-guide-image {
  margin-top: 38px;
}

.android-download-button {
  display: block;
  width: 500px;
  height: 92px;
  margin: 40px auto 0;
  padding: 0;
  color: #fff;
  font-size: 30px;
  font-weight: 700;
  background: #00d9c5;
  border-radius: 48px;
}

.newsdetails-content {
  padding: 32px;
  background-color: #fff;
  min-height: 100vh;
}

.newsdetails-content.has-share-entry {
  box-sizing: border-box;
  padding-bottom: calc(168px + env(safe-area-inset-bottom));
}

.newsdetails-content .main-title {
  font-size: 38px;
  color: #333;
  font-weight: 700;
  margin-top: 20px;
}

.contentbox {
  display: flex;
  align-items: center;
  margin-top: 18px;

}

.contentbox .tapv {
  color: #12cdb0;
  font-size: 24px;

}
.contentbox .line {
  height: 20px;
  width: 1px;
  background-color: #ccc;
  color: #ccc;
  margin-left: 12px;
  margin-right: 12px;
}
.contentbox .timev {
  color: #999;
  font-size: 24px;
}

::v-deep .newsdetails-content p {
  font-size: 26px;
  color: #000;
}

.article-content {
  margin-top: 24px;
}

/* 兼容旧样式 */
.newsdetails-content /deep/ img {
  max-width: 100%;
}
::v-deep .newsdetails-content p span {
  text-wrap: wrap !important;
}
:deep(.withImage) {
  height: 200px;
  width: 200px;
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 999999;
}
:deep(.van-overlay) {
  background-color: rgba(0, 0, 0, 1);
}
.withImage img {
  border: none;
  width: 100px;
  height: 100px;
  background-color: #333;
  color: #fff;
  border-radius: 50%;
  font-size: 28px;
}

@media (orientation: landscape) {
  :deep(.share-guide-popup) {
    width: min(660px, 82vw);
  }

  .share-open-button {
    bottom: calc(18px + env(safe-area-inset-bottom));
  }
}



</style>
